import type * as React from "react";
import type { Metadata } from "next";
import { Footer, Header } from "@/components/layout";
import { StoreProvider } from "@/components/providers";
import { fontClassNames } from "@/lib/site/fonts";
import { siteConfig } from "@/lib/site/navigation";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./globals.css";

export const metadata: Metadata = {
  title: {
    default: siteConfig.name,
    template: `%s | ${siteConfig.name}`,
  },
  description: siteConfig.tagline,
};

type RootLayoutProps = Readonly<{
  children: React.ReactNode;
}>;

const RootLayout: React.FC<RootLayoutProps> = ({ children }) => {
  return (
    <html
      lang="en"
      className={`${fontClassNames} h-full antialiased`}
    >
      <body className="flex min-h-full flex-col font-sans">
        <StoreProvider>
          <Header />
          <main className="flex-auto">{children}</main>
          <Footer />
        </StoreProvider>
      </body>
    </html>
  );
};

export default RootLayout;
